// Generated by CoffeeScript 1.12.7

/**
Checks is a string has markdown in it.
Only test for bold,italics,images,links

@method hasMarkdown
@param {String} string string to test
@return {Boolean}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/has_markdown',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.hasMarkdown = factory();
  }
})(this, function() {
  var hasMarkdown;
  return hasMarkdown = function(string) {
    var exp;
    exp = /(\*\*?|__?)(.+?)(\*\*?|__?)|!?\[([^\[]+)\]\(([^\)]+)\)/ig;
    return exp.test(string);
  };
});

